import { Navigate } from 'react-router-dom';
import { useMaintenance } from '../context/MaintenanceContext';
import { Settings } from 'lucide-react';

export const MaintenanceGuard = ({ children }) => {
  const { isMaintenanceMode, loading } = useMaintenance();

  // Show loading spinner while checking maintenance status
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Settings className="w-8 h-8 text-primary animate-spin" />
      </div>
    );
  }

  // Redirect to maintenance page if maintenance mode is active
  if (isMaintenanceMode) {
    return <Navigate to="/maintenance" replace />;
  }

  // Render children (public routes) if not in maintenance mode
  return children;
};
